/**
 * Pantalla: Mapa40
 * Component: PantMapa40.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per mostrar indicadors en un mapa
 */

import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Button, Checkbox, InputBase, FormControlLabel, IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import OlLayerImage from 'ol/layer/Image';
import OlImageSource from 'ol/source/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import Mapa40State from '../states/Mapa40State';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/Guia.css';
import { ExpandMore, Link, } from '@material-ui/icons';
import { ILayer, IFilterGroup, IUrl } from '../interfaces/ILayer';
import { AppDrawer, AppToolBar, AppToolBarElements } from 'ajt-app';

@inject('appState')
@observer
export default class PantMapa40 extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mpState - Els paràmetres el processem dins de createMap de GuiaState
        this.m40State = new Mapa40State(this.props);
        // Events pel canvi de mida de la pantalla
        this.m40State.updateWindowSize();
        this.autoSize = true;
    }

    // El estat del mapa
    private m40State: Mapa40State;

    // Diu si agafem les mides de la pantalla
    private autoSize = false;
    private readonly resizeHandler = this.updateDimensions.bind(this);

    updateDimensions() {
        if (this.autoSize) {
            this.m40State.updateWindowSize();
        }
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.resizeHandler);
        }
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }

    // Hem canviat de BaseLayer
    private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
        this.m40State.actBaseLayer = layerSelected;
        // La capa de noms només la volem activa als layers de Planejament i Ortofoto
        if (this.m40State.nomsLayer) {
            const id: string = layerSelected.get('id');
            const ld: ILayer = this.m40State.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
            if (ld && ld.noms) {
                this.m40State.nomsLayer.set('visible', this.m40State.nomsVisible);
                this.m40State.setShowNoms(true);
            } else {
                this.m40State.nomsLayer.set('visible', false);
                this.m40State.setShowNoms(false);
            }
        }
    }

    // Activem o desactivem la capa de noms
    private handleCBNomsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.m40State.nomsLayer.setVisible(event.target.checked);
        this.m40State.setNomsVisible(event.target.checked);
    };

    //funcio per fer "querys"
    // Rederitza un FilterGroup
    private renderFilterGroup = (fg: IFilterGroup) => {
        if (fg.type === 'filter') {
            const formlabel = [<></>];
            fg.elements.forEach(element => {
                formlabel.push(
                    <FormControlLabel
                        style={{ fontSize: '12px', padding: 0, marginLeft: 2 }}
                        control={<Checkbox
                            id={fg.feature + element.value}
                            onChange={() => {
                                const filterExists = this.m40State.filters.some((e) => e.feature == fg.feature && e.value == element.value);
                                if (!filterExists) {
                                    this.m40State.boxcheked.push(fg.feature + element.value);
                                    this.m40State.filters.push({ feature: fg.feature, value: element.value })
                                } else {
                                    if (this.m40State.boxcheked.includes(fg.feature + element.value)) {
                                        this.m40State.boxcheked.splice(this.m40State.boxcheked.indexOf(fg.feature + element.value), 1);
                                    }
                                    for (let i = 0; i < this.m40State.filters.length; i++) {
                                        const element2 = this.m40State.filters[i];
                                        if (element2.feature == fg.feature && element2.value == element.value) {
                                            this.m40State.filters.splice(i, 1);
                                        }
                                    }
                                }
                                this.m40State.setqSelect(this.m40State.refLayers[0], this.m40State.getLayerExtraParms2(this.m40State.mapConfig.refLayers[0] as ILayer).qfilter);
                                this.m40State.refLayers[0].getSource().refresh();
                            }}
                        />}
                        label={element.name} 
                    />
                )
            });
            return (<Accordion square elevation={0} style={{ padding: 0, minHeight: 20 }} key={'ac' + fg.id}>
                <AccordionSummary key={'gr' + fg.id} expandIcon={<ExpandMore />} style={{ height: 32, maxHeight: 32, minHeight: 20 }}>
                    {!!fg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + fg.icon} alt={fg.name} width={16} height={16} />&nbsp;</>}
                    <Typography variant="body2">{fg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: 'grid', padding: 0, minHeight: 20 }} key={'acd' + fg.id}>
                    {formlabel}
                </AccordionDetails>
            </Accordion>);
        } else {
            return null;
        }
    }

    private handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.m40State.setAnchorEl(event.currentTarget)
    }

    private handleMenuClose = (index: number) => {
        this.m40State.setAnchorEl(null);
        if (index >= 0) {
            window.open(this.m40State.mapConfig.descarrega[index].url, this.m40State.mapConfig.descarrega[index].name);
        }
    }

    // Mostra un diàleg amb l'enllaç
    private handleGetLink = () => {
        // Posar un popup amb el link
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname;
        // Centre del mapa i Zoom
        const c = this.m40State.olview.getCenter();
        url += '?Pos=' + c[0].toFixed(2) + ';' + c[1].toFixed(2) + ';' + this.m40State.olview.getZoom().toFixed(0);
        // Marcador
        if (this.m40State.position) {
            url += ';' + this.m40State.position[0].toFixed(2) + ';' + this.m40State.position[1].toFixed(2);
        }
        // BaseLayer
        const id: string = this.m40State.actBaseLayer.get('id');
        const ld: ILayer = this.m40State.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
        url += '&Base=' + ld.layers;

        this.props.appState.dialState.messageBox({
            title: 'Enllaç',
            message: url,
            buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
        }).then((result) => {
            if (result === 'Copiar URL') {
                navigator.clipboard.writeText(url);
                this.props.appState.notiState.showMessage('URL copiada');
            }
        });
    }

    render() {
        if (!this.m40State.configOk) {
            return null;
        }

        const w: number = this.m40State.width; // Amplada de la finestra
        const drw: number = this.props.appState.menuState.marginDrawer; // Amplada el drawer
        const wx: string = (w - drw).toString() + 'px'; // Amplada del mapa

        const mto: string = w < 601 ? (w < 600 ? '96px' : '112px') : '112px'; // Posició top del mapa
        const h: number = this.m40State.height - 106 + (w < 601 ? (w < 600 ? 16 : 8) : 0); // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        const lx: string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        const bx: string = 'calc(100% - ' + (h + (w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        const thc = w < 601 ? (w < 600 ? '106px' : '122px') : '122px';  // Posició (superior) del control de capa de noms
        const rhc = 'calc(100% - ' + (w + 5).toString() + 'px)'; // Posició (dreta) del control de capa de noms

        return (
            <>
                <AppToolBar style={{ zIndex: 1300 }} showHelp={true}>
                    <AppToolBarElements alignment='right'>
                        {this.m40State.mapConfig.descarrega && this.m40State.mapConfig.descarrega.length > 0 && <><Button onClick={this.handleMenuClick}>Descàrrega de mapes ...</Button>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.m40State.anchorEl}
                                keepMounted
                                open={Boolean(this.m40State.anchorEl)}
                                onClose={this.handleMenuClose.bind(this, -1)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                            >
                                {this.m40State.mapConfig.descarrega.map((item: IUrl, index: number) => {
                                    return (<MenuItem key={'dsc' + index} onClick={this.handleMenuClose.bind(this, index)}>{item.name}</MenuItem>);
                                })}
                            </Menu></>}
                        <Tooltip title="Enllaçar">
                            <IconButton onClick={this.handleGetLink} key="iblink">
                                <Link />
                            </IconButton>
                        </Tooltip>
                    </AppToolBarElements>
                </AppToolBar>
                <AppDrawer variant={w < 601 ? 'temporary' : 'permanent'}>
                    {
                        <>
                            <InputBase
                                placeholder="Search"
                                fullWidth={true}
                                className="ibase"
                                onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                                    this.m40State.nomFilter = event.target.value;
                                    this.m40State.setqSelect(this.m40State.refLayers[0], this.m40State.getLayerExtraParms2(this.m40State.mapConfig.refLayers[0] as ILayer).qfilter);
                                    this.m40State.refLayers[0].getSource().refresh();
                                }}
                            />
                            {this.m40State.mapConfig.filters.map((fg) => {
                                return this.renderFilterGroup(fg);
                            })}
                        </>
                    }
                </AppDrawer>
                <>
                    {this.m40State.olmap && <MapComponent map={this.m40State.olmap} style={{ width: wx, height: hx, cursor: this.m40State.identPosition ? 'crosshair' : this.m40State.identElement ? 'pointer' : 'default', position: 'fixed', top: mto }} />}
                    {this.m40State.olmap && <MyZoomToExtent map={this.m40State.olmap} tooltip="Zoom total" extent={this.m40State.mapConfig.initialExtent} />}
                    {this.m40State.baseLayers.length === 2 && <MyLayerSwitcher
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2
                        }}
                        map={this.m40State.olmap}
                        layers={this.m40State.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls1"
                    />}
                    {this.m40State.baseLayers.length > 2 && <MyLayerSwitcher2
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2,
                            backgroundColor: 'rgba(250, 250, 250, 0.8)'
                        }}
                        map={this.m40State.olmap}
                        layers={this.m40State.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls2"
                    />}
                    {this.m40State.showNoms && <FormControlLabel
                        style={{ zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc }}
                        control={<Checkbox
                            checked={this.m40State.nomsVisible}
                            onChange={this.handleCBNomsChange}
                            name="cbNoms"
                        />}
                        label={<Typography variant="body2">{this.m40State.nomsLayer.get('name')}</Typography>}
                        title='Activar o desactivar la capa de noms de carrers i de números postals'
                    />}
                </>
            </>
        );
    }
}